import { observable } from "mobx";
import GainLossUnitPriceAPI from "../services/gainloss-unitprice-screen-service";
import GainLossListsScreenAPI from "../services/gainloss-lists-screen-service";
import { AppConstants, Types } from "../../../common/APIConstants";

class GainLossUnitPriceDataStore {
  @observable screenRowData = {
    UnitPriceData: [],
    SystemData: [],
  };
  @observable screenColumnDefinitions = {
    unitPriceTemplate: [],
  };

  @observable hasScreenData = false;

  getUnitPriceData = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const { data } = await GainLossUnitPriceAPI.getUnitPriceData();
      this.screenRowData.UnitPriceData = data;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
    }
  };

  setScreenData = (data) => (this.screenRowData.UnitPriceData = data);

  resetVendorData = () => {
    this.screenRowData.UnitPriceData = [];
    this.hasScreenData = false;
  };
  getScreenData = async (CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    this.screenRowData.UnitPriceData = [];
    try {
      const { data } = await GainLossUnitPriceAPI.getUnitPriceData();
      this.screenRowData.UnitPriceData = data;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;
        this.screenColumnDefinitions[child.screen.name] = [];

        this.screenColumnDefinitions[child.screen.name] =
          this.getAllColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: "text",
        hide: column.hidden,
        width: column.width ? column.width : 200,
        keyCreator: (params) => {
          return this.getValueFomatter(params, column, screen)
            ? this.getValueFomatter(params, column, screen)
            : params.value;
        },
        editable: (params) => {
          return this.getIsEditable(params, column, screen);
        },
        cellClassRules: {
          "highlight-cell": (params) => {
            return this.getIsEditable(params, column, screen);
          },
          "grid-cell-custom": (params) => {
            return params.data ? true : false;
          },
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) =>
          this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => {
          return this.getValueFomatter(params, column, screen);
        },
        cellStyle: (params) => {
          if (column?.readOnly && !params?.node?.data?.isNewRow) {
            return { backgroundColor: "LightGray" };
          }
        },
      });
    });
    return gridColumns;
  };

  getValue(params, screen, column) {
    return params.data[column.name];
  }
  getIsEditable(params, column, screen) {
    if (column.name === "effectiveStartDate" || column.name === "system") {
      return !params?.node?.data?.unitPriceId;
    } else if (this.getIsDataReadOnly() || !params.data) return false;
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {
    /* Uncomment any of this to disable the editing on screen for past dates OR a week before */

    // return moment(this.headerDetails.endDateTime).isBefore(moment(), "day");
    // return moment(this.headerDetails.endDateTime).isBefore(moment().subtract(7, "days"), "day");
    return false;
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return "booleanCellEditor";
      case Types.DATE:
        return "dateFormatter";
      case Types.DATETIME:
        return "dateTimeFormatter";
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.NUMBER:
        return "numericCellEditor";
      case Types.DECIMAL:
        return "decimalCellEditor";
    }
  }
  getCellEditorParams(column, params) {
    switch (column.type) {
      case Types.DROPDOWN:
        if (column.name === "system") {
          return {
            values: this.SystemData?.map((item) => {
              return { label: item?.entityName, value: item?.entityName };
            }),
          };
        } else
          return {
            values: column.refLookupData?.lookupValues.values,
            isPopup: true,
          };
    }
  }

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.name === "price") {
        const price = parseFloat(`${params.value}`.replace(/,/g, ""));
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        })
          .format(price)
          .replace("$", "");
      } else if (
        column.type === Types.DROPDOWN &&
        column.refLookupData != null
      ) {
        return this.lookupValue(
          column.refLookupData.lookupValues,
          params.value
        );
      }

      // if (screen.name === "ProductSpec" && (column.name === "DailyAvgValue" || column.name === "InstantValue")) {
      //   return (params.node.data.Parameter === "C3 Treater Moisture" && params.value == "99") ? "Bypassed" : params.value;
      // }
    }
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }

  getSystemData = async () => {
    try {
      const response = await GainLossListsScreenAPI.getEntityList({
        jurisdiction: "Plains - North",
        entityType: "System",
      });

      this.SystemData = response?.data.filter((item) => item.isActive);
    } catch (error) {
      window.toastr.error(
        AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES
          .SYSTEM_DATA_ERROR
      );
    }
  };

  saveUnitPriceData = async (CommonStore, unitPriceData) => {
    CommonStore.toggleLoader();
    try {
      const { data } = await GainLossUnitPriceAPI.saveUnitPriceData({
        UnitPriceDataRequests: unitPriceData,
      });
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES.SAVE_SUCCESS
      );
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES
            .SAVE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.GAIN_LOSS.UNIT_PRICE_SCREEN.TOAST_MESSAGES
            .SAVE_GENERIC_ERROR
        );
      }
    }
  };
}

export default new GainLossUnitPriceDataStore();
